import { render, staticRenderFns } from "./PThumbnailImage.vue?vue&type=template&id=b7933f7c"
import script from "./PThumbnailImage.vue?vue&type=script&lang=js"
export * from "./PThumbnailImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports